<template>
    <Head>
        <title>{{title}}</title>
        <meta name="description" :content="description">
    </Head>
    <Header :agency="agency" :bg_img="bg_img"></Header>
    <Layout>
        <div class="content-blocks">


            <section class="page-header-section half-view-header ">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2026/01/NOS_SERVICES_EWIGO_AUTO_1.png')">
                </div>
                <div class="container">
                    <h1 class="h1 white anim fade up">Nos services</h1>
                    <div class="links-list anim fade up delay1">

                        <a class="btn primary-btn" href="#packs">Packs</a>
                        <a class="btn primary-btn" href="#financement">Financement</a>
                        <a class="btn primary-btn" href="#fiable-ou-rembourse">Fiable ou remboursé</a>
                        <a class="btn primary-btn" href="#garantie">Garantie</a>
                        <a class="btn primary-btn" href="#livraison">Livraison</a>
                        <a class="btn primary-btn" href="#paiement-securise">Paiement sécurisé</a>
                        <a class="btn primary-btn" href="#carte-grise">Carte grise</a></div>
                </div>
            </section>


            <section class="video-with-content-section ">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="video-block anim fade right">
                                <iframe width="1280" height="370"
                                        src="https://www.youtube.com/embed/80rmk8JV1gw?autoplay=0"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer;autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                            </div>
                        </div>
                        <div class="col-lg-6 text-video">
                            <p class="anim fade left">
                                <p class="center-mobile"><b>Une expérience client qui vous ressemble !</b></p><br><br>
                                Animés par nos valeurs : Confiance, Sécurité et Satisfaction, nous
                                nous dépassons chaque jour pour vous permettre d’obtenir le meilleur. <br><br> Vous êtes
                                unique, votre projet auto également. C’est pourquoi, les ambassadeurs Ewigo construisent
                                à vos côtés une offre sur mesure, afin de vous apporter une expérience client
                                d’exception. <br><br> En effet, au sein de notre réseau, vous bénéficiez de véhicules
                                rigoureusement sélectionnés et d’une écoute attentive pour mener à bien votre projet
                                auto. Grâce à nos nombreux services associés, nous saurons vous offrir bien plus qu’une
                                voiture et vous apporter une pleine satisfaction pour parcourir les routes en toute
                                sérénité.</p>
                        </div>
                    </div>
                </div>
            </section>


            <section class="the-packs-section" id="packs">
                <div class="section-header">
                        <h2 class="h2 anim slide-right">Les packs</h2>
                    </div>
                <div class="container">
                    <!--<hr class="light">-->
                    <p class="anim slide-right" style="margin-top:20px">
                        Chez Ewigo nous avons créé 3 packs de livraison lors de l’achat d’un véhicule d’occasion.
                        Du clé en main au prestige en passant par le sérénité chaque pack est pensé pour s’adapter à votre besoin.                     </p>
                    <div class="list-block row">
                        <div class="list col-lg-4 border-right-orange">
                            <div class="image-block anim flip">
                                <img src="https://www.ewigo.com/wp-content/uploads/2025/06/cle-en-main-pack.png" alt="">
                                <!-- <lottie-player
                                        src="/img/start.json"
                                        background="transparent" speed="1" style="width: 100%;max-width:80%" loop
                                        autoplay></lottie-player> -->
                            </div>
                            <h3 class="h3 primary anim slide-right">Pack clés en main</h3>
                            <div class="price-subtitle">691 € TTC*</div>
                            <div class="pack-text">
                                Démarches administratives
                                <br>1/4 du réservoir d’essence minimum
                                <br>Nettoyage First
                                <br>Label fiable ou remboursé
                                <br>Garantie Européenne InitialePro
                                <br>Mutuaide 6 mois offert**
                            </div>
                        </div>
                        <div class="list col-lg-4 border-right-orange">
                            <div class="image-block anim flip"><img
                                    src="https://www.ewigo.com/wp-content/uploads/2025/06/Serenite-pack-e1749637512393.png" alt="">
                            </div>
                            <h3 class="h3 primary anim slide-right">Pack sérénité</h3>
                            <div class="price-subtitle">891 € TTC*</div>
                            <div class="pack-text">
                                Démarches administratives
                                <br>1/2 du réservoir d’essence minimum
                                <br>Nettoyage Confort
                                <br>Label fiable ou remboursé
                                <br>Garantie Européenne InitialePro
                                <br>Mutuaide 12 mois offert**
                            </div>
                        </div>
                        <div class="list col-lg-4">
                            <div class="image-block anim flip">
                                <img src="https://www.ewigo.com/wp-content/uploads/2025/06/Prestige-pack.png" alt="">
                                <!-- <lottie-player
                                        src="/img/cerise.json"
                                        background="transparent" speed="1" style="width: 100%" loop
                                        autoplay></lottie-player> -->
                            </div>
                            <h3 class="h3 primary anim slide-right">Pack prestige</h3>
                            <div class="price-subtitle">1.091 € TTC*</div>
                            <div class="pack-text">
                                Démarches administratives
                                <br>Plein du réservoir d’essence
                                <br>Nettoyage prestige
                                <br>Label fiable ou remboursé
                                <br>Garantie Européenne Optimale/Idéale Pro
                                <br>Mutuaide 12 mois offert**
                                <br>La surprise du chef
                            </div>
                        </div>
                    </div>

                    <br><br>
                    <p class="sub">*Tarif pour les véhicules deux roues motrices dont la valeur neuve hors options est inférieure à 60.000 € TTC. <br>
                        **Selon l’article L217-3 du Code de la consommation, il n’est pas possible de revendre le produit de garantie Mutaide Pro au client bénéficiaire. La garantie doit être systématiquement offerte au client bénéficiaire.
                    </p>
                </div>
            </section>

            <section class="content-with-left-image-section full-width">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="image-block anim fade right"><img
                                    src="https://www.ewigo.com/wp-content/uploads/2026/01/VEHICULE_COMME_NEUF_EWIGO.png"
                                    alt=""></div>
                        </div>
                        <div class="col-lg-6">
                            <p class="anim fade left text-padding">

                                <span style="font-weight:bold; font-size:20px">Un véhicule comme neuf !</span><br><br>

                                Plus qu'un service de nettoyage professionnel, redécouvrez à travers notre service le plaisir de disposer d'un véhicule propre et confortable. Parce qu'occasion peut rimer avec perfection, nous vous proposons des solutions de nettoyage professionnelles, afin de profiter d'un véhicule comme neuf !<br><br>
                                Du simple nettoyage à la préparation esthétique minutieuse de votre véhicule, retrouvez plusieurs niveaux de services pour la mise en beauté de celui-ci. A travers nos différents packs et notamment du confort au prestige, bénéficiez de nettoyages extérieurs et intérieurs, effectués à la main, pour une finition optimale.<br><br>
                                Parce qu'au-delà de la dimension esthétique, un lavage permet de protéger votre véhicule face aux éléments extérieurs et ainsi de rouler en toute sécurité, nous considérons qu'une bonne préparation de votre voiture reste primordiale.<br><br>
                                Alors, avec quel pack souhaitez-vous prendre la route ?
                            </p>

                        </div>
                    </div>
                </div>
            </section>

            <section class="content-with-right-image-section full-width">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">

                            <p class="anim fade right text-padding">
                                <span style="font-weight:bold; font-size:20px">Des démarches administratives facilitées</span><br><br>
                                La transaction d'un véhicule entre particuliers engendre des démarches administratives fastidieuses. Pour que votre projet auto reste un plaisir, nous nous occupons de l'intégralité des démarches liées à la vente ou à l'achat de votre véhicule.<br><br>
                                Profitez d'un service totalement digitalisé et de documents mis à votre disposition grâce à nos outils numériques sécurisés.<br><br>
                                Un transfert de propriété simple et rapide, c'est désormais possible avec Ewigo !
                            </p>
                        </div>
                        <div class="col-lg-6 img-right">
                            <div class="image-block anim fade left"><img
                                    src="https://www.ewigo.com/wp-content/uploads/2026/01/DEMARCHES_ADMINISTRATIVES_EWIGO.png"
                                    alt=""></div>

                        </div>
                    </div>
                </div>
            </section>

            <section class="funding-section" id="financement">
                <div class="image-block"
                     style="background-image: url('https://www.ewigo.com/wp-content/uploads/2026/02/livret_ewigo-scaled.jpg')">
                </div>
                <div class="container">
                    <div class="section-header">
                        <img src="https://www.ewigo.com/wp-content/uploads/2022/01/Icone-financement.png"
                             alt="Financement">
                        <div class="line"></div>
                        <h2 class="h2 right anim slide-right">Le financement</h2>
                    </div>
                    <!--
                        <h2 class="h2 right anim slide-right">Le financement</h2>                        <hr class="light">
                        -->
                    <div class="row">
                        <div class="col-lg-7">
                            <p class="anim fade up">
                            <h3><span style="font-weight: 300;">Votre offre de prêt en quelques clics ! </span></h3>
                            <h4><span style="font-weight: 300;">Comment ça marche ? </span></h4>
                            <ul>
                                <li style="font-weight: 300;" aria-level="1"><span
                                    style="font-weight: 300;">Réalisez votre demande de financement sur la fiche
                                            du véhicule de votre choix et recevez jusqu’à <span style="white-space: nowrap">4 offres</span>, de nos 4 banques
                                            partenaires. </span></li>
                                <li style="font-weight: 400;" aria-level="1"><span
                                    style="font-weight: 400;">Complétez le formulaire unique en 3 minutes.</span>
                                </li>
                                <li style="font-weight: 400;" aria-level="1"><span
                                    style="font-weight: 400;">Sélectionnez les banques de votre choix, obtenez
                                            des accords de principe instantanés et choisissez l&rsquo;offre qui vous
                                            convient.</span></li>
                                <li style="font-weight: 400;" aria-level="1"><span
                                    style="font-weight: 400;">Finalisez votre demande et envoyez les pièces
                                            justificatives.</span></li>
                                <li style="font-weight: 400;" aria-level="1">Consultez votre compte bancaire, les
                                    fonds vous seront délivrés en quelques jours.
                                </li>
                            </ul>
                            </p>
                        </div>
                        <div class="col-lg-5">
                            <div class="form-section">
                                <h3 class="h3">Votre financement</h3>
                                <div class="list">
                                    <ul class="checklist">
                                        <li>
                                            <p>Votre financement en moins de 5 minutes</p>
                                        </li>
                                        <li>
                                            <p>Une réponse de principe instantanée</p>
                                        </li>
                                        <li>
                                            <p>Sans engagement</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="form-block range-calculator pointer-events-none">
                                    <div class="form-group range-input">
                                        <label for="">
                                            <span class="main">Durée</span>
                                            <span>
                                                <p class="sub">60 mois</p>
                                            </span>
                                        </label>
                                        <div class="input-block">
                                            <input type="range" name="" id="range1" min="0" max="100">
                                        </div>
                                    </div>
                                    <div class="form-group range-input">
                                        <label for="">
                                            <span class="main">Apport</span>
                                            <span>
                                                <p class="sub">2400 euros</p>
                                            </span>
                                        </label>
                                        <div class="input-block">
                                            <input type="range" name="" id="range2" min="0" max="100">
                                        </div>
                                    </div>
                                    <div class="answer-block">
                                        <p>60 mois</p>
                                        <p>à partir de * <b><span class="primary">147.35 €</span>/mois</b></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="reliable-section" id="fiable-ou-rembourse">
                <div class="container reliable-wrapper">
                    <div class="section-header">
                        <img src="https://www.ewigo.com/wp-content/uploads/2023/02/fiable-ou-rembourse-1.png" alt="Logo fiable ou remboursé">
                        <div class="line"></div>
                        <h2 class="h2 anim slide-right">Le label Fiable ou remboursé</h2>
                    </div>

                    <div class="reliable-criterias">
                        <h3 class="h3 anim slide-right">Les critères d'éligibilités</h3>
                        <div class="criterias">
                            <!-- criteria 1 -->
                            <div class="criteria">
                                <div class="criteria-image counter"></div>
                                <div class="criteria-text">
                                    <p>Moins de 150 000 km moins de 15 ans</p>
                                </div>
                            </div>
                            <!-- criteria 2 -->
                            <div class="criteria">
                                <div class="criteria-image calendar"></div>
                                <div class="criteria-text">
                                    <p>Valeur d’achat en <strong>occasion</strong> inférieure à 60 000€</p>
                                </div>
                            </div>
                            <!-- criteria 3 -->
                            <div class="criteria">
                                <div class="criteria-image gear"></div>
                                <div class="criteria-text">
                                    <p>Véhicule dont le prix d’achat <strong>neuf</strong> est inférieur à 100 000€</p>
                                </div>
                            </div>
                            <!-- criteria 4 -->
                            <div class="criteria">
                                <div class="criteria-image car"></div>
                                <div class="criteria-text">
                                    <p>Véhicule particulier non destiné à un usage pro*</p>
                                </div>
                            </div>
                        </div>

                        <div class="reliable-durations">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="reliable-container">
                                        <h3 class="h3 anim slide-right">Durée du label</h3>
                                        <div class="durations">
                                            <div class="duration">6 mois</div>
                                            <div class="duration">moins de 10 000 km après achat</div>
                                        </div>
                                        <span class="durations-info">au premier des deux termes atteint</span>

                                        <div class="not-reliable">
                                            <p>Un véhicule est réputé non fiable lorsqu’il subit 2 pannes complètes (incluant les 3 critères suivants) :</p>
                                            <ul>
                                                <li>immobilisantes de plus de 72h</li>
                                                <li>dont la panne nécessite plus de 8h d’intervention <em>(base: indice barème constructeur)</em></li>
                                                <li>non prise en charge par le programme de garantie</li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="reliable-container solution-bloc">
                                        <h3 class="h3 anim slide-right">Quelle solution si mon véhicule est non fiable ?</h3>
                                        <div class="solution">
                                            <p><strong>Remboursement de l’intégralité du véhicule</strong> hors prix de carte grise, sous réserve de restitution du véhicule à l’état identique de celui du jour d’achat.</p>
                                        </div>
                                        <img src="https://www.ewigo.com/wp-content/uploads/2023/02/illlustration-voiture-avatar.png" alt="Illustration" class="reliable-illustration">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="warranty-section" id="garantie">
                <div class="container">
                    <div class="section-header">
                        <h2 class="h2 anim slide-right">La garantie</h2>
                        <div class="line"></div>
                        <img src="https://www.ewigo.com/wp-content/uploads/2022/01/badge.png" alt="Livraison">


                    </div>
                    <p><span style="font-weight: 400;">Parce que nous sommes le réseau numéro 1 d’agences automobiles, nous souhaitons être accompagnés par le leader en termes de garanties mécaniques et largement reconnu pour son haut niveau de qualité.&nbsp;</span></p>
                    <p>&nbsp;</p>
                    <p><span style="font-weight: 400;">Vous bénéficiez automatiquement d’une offre de garanties 6 mois offertes pour tout nouveau véhicule et adaptées et personnalisées selon vos besoins.</span></p>
                    <p>&nbsp;</p>
                    <p><span style="font-weight: 400;">Traverser les routes l’esprit léger en France, en Europe et bien plus encore,&nbsp; dans tous les pays inscrits sur la carte verte de votre assurance, en profitant d’une garantie allant jusqu’à 60 mois,&nbsp;</span></p>
                    <p><span style="font-weight: 400;">*incluant vétusté, assistance panne mécanique, électronique ainsi qu’un véhicule de remplacement.</span></p>
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="image-block"><img
                                src="/img/tableau-garantie.png" alt="Tableau comparatif formules"
                                class="img-fluid border"></div>
                        </div>
                        <div class="col-lg-5">
                            <div class="image-block"><img
                                src="/img/logo-mutuaide.png"
                                alt="Logo Mutuaide by Groupama" class="logo-mutuaide"></div>
                            <div class="sub_description">
                                <p class="anim slide-right">
                                    <p>Parce que nous sommes le réseau numéro 1 d’agences automobiles, nous souhaitons être accompagnés par un partenaire spécialiste de la garantie de l'assistance largement reconnu.</p>
                                    <p>Fort d’une expérience de plus de 40 ans, Mutuaide filiale de GROUPAMA est un leader européen en garanties automobiles, vous proposant une offre <b>adaptée et personnalisée.</b></p>

                                    <p>À votre écoute 7j/7, 24h/24, Mutaide s’engage <b>à vous accompagner</b> partout en Europe afin de vous garantir <b>un haut niveau de qualité*.</b></p>
                                    <p><small>*incluant vétusté, assistance panne mécanique, électronique ainsi qu’un véhicule de remplacement.</small></p>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section class="the-delivery-section" id="livraison">
                <div class="container">
                    <div class="section-header">
                        <img src="https://www.ewigo.com/wp-content/uploads/2022/01/expedie.png" alt="Livraison">
                        <div class="line"></div>
                        <h2 class="h2 right anim slide-right">La livraison</h2>
                    </div>
                    <!--<hr class="light">-->
                    <div class="row">
                        <div class="col-lg-5">
                            <div class="image-block"><img
                                src="https://www.ewigo.com/wp-content/uploads/2026/01/LIVRAISON_EWIGO.png"
                                alt="" class="img-fluid"></div>
                        </div>
                        <div class="col-lg-7">
                            <p class="anim fade left">
                            <h3>La livraison par Driiveme Pro !</h3>
                            <p class="livraison-subtitle">Leader sur le marché de la logistique automobile, Driiveme Pro est <b>la solution
                                adaptée</b> pour la livraison de votre véhicule en toute <b>sécurité et simplicité.</b></p>
                            <ul>
                                <li><b>Un chauffeur professionnel</b> sera mandaté pour effectuer la livraison de votre
                                    véhicule, où vous le désirez (domicile, travail…).
                                </li>
                                <li>Dès lors que le chauffeur aura pris en main votre véhicule, vous pourrez
                                    consulter en <b>temps réel</b> sa livraison.
                                </li>
                                <li>À la réception de votre véhicule, <b>l'ensemble des documents</b> relatifs à l’achat
                                    vous seront fournis par le chauffeur.<br/>
                                    <b>Une vérification intégrale</b> sera effectuée et vous pourrez ensuite <b>signer votre
                                    contrat.</b>
                                </li>
                            </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            <section class="the-packs-section" id="paiement-securise">
                <div class="section-header">
                    <h2 class="h2 anim slide-right">Le paiement sécurisé</h2>
                </div>
                <div class="container">
                    <!--<hr class="light">-->
                    <p>&nbsp;</p>
                    <p class="anim slide-right">
                        <p><span style="font-weight: 400;">
                                Ewigo vous offre une solution dédiée à la sécurisation des paiements lors de l'achat ou la vente de votre véhicule.
                                Notre partenaire CashSentinel, reconnu par la Banque de France, vous propose une alternative digitale et sécurisée aux chèques de banque.
                            </span>
                        </p>
                    </p>

                    <div class="list-block row">
                        <div class="list col-lg-4">
                            <div class="image-block anim flip"><img
                                src="https://www.ewigo.com/wp-content/uploads/2022/02/cashsentinel-1.png"
                                alt=""></div>

                            <p class="anim slide-right delay1" style="font-weight:bold; font-size:20px; text-align: center">Suivi en temps réel</p>
                            <p class="anim slide-right delay1 center">
                                <!-- Vérification des documents et de l’identité du client
                                vendeur et du client acheteur. -->
                                Une vérification des documents du contrat
                                et des identités est effectuées. Acheteur ou
                                vendeur, vous bénéficiez d'un suivi en temps
                                réel sur l’avancement de votre transaction.
                            </p>
                        </div>
                        <div class="list col-lg-4">
                            <div class="image-block anim flip"><img
                                src="https://www.ewigo.com/wp-content/uploads/2022/02/cashsentinel-2.png"
                                alt=""></div>
                            <p class="anim slide-right delay1" style="font-weight:bold; font-size:20px; text-align: center">Sécurité avant tout</p>
                            <p class="anim slide-right delay1 center">
                                <!-- Sécurisation des fonds sur un compte séquestre jusqu’à la
                                livraison du véhicule. -->
                                Les fonds sont protégés pour l'acheteur et le
                                vendeur sur un compte séquestre, en France,
                                jusqu'au complet déroulement de la transaction.
                                Le versement est immédiat, irrévocable et sécurisé.
                            </p>
                        </div>
                        <div class="list col-lg-4">
                            <div class="image-block anim flip"><img
                                src="https://www.ewigo.com/wp-content/uploads/2022/02/cashsentinel-3.png"
                                alt=""></div>
                            <p class="anim slide-right delay1" style="font-weight:bold; font-size:20px; text-align: center">Protection juridique</p>
                            <p class="anim slide-right delay1 center">
                                Vous bénéficiez dès lors d'une double protection
                                financière et contractuelle grâce à la compagnie
                                Allianz qui interviendra en cas de litige jusqu'à
                                3 mois après la transaction.
                            </p>
                        </div>
                    </div>
                    <br><br>
                </div>
            </section>


            <section class="the-grey-card-section" id="carte-grise">
                <div class="container">
                    <div class="section-header">
                        <img src="https://www.ewigo.com/wp-content/uploads/2022/01/ICONE-CARTE-GRISE.png"
                             alt="Livraison">
                        <div class="line"></div>
                        <h2 class="h2 right anim slide-right">La carte grise</h2>
                    </div>
                    <div class="row">
                        <div class="col-lg-7">
                            <p class="anim fade left">
                            <h3>La carte grise par Ewigo !</h3>
                            <p>Ewigo est accrédité par <b>l’organisme de l’ANTS</b> afin de pouvoir éditer et délivrer <b>les
                                certificats d’immatriculation</b> pour votre véhicule.</p>
                            <ul>
                                <li><b>L’établissement de la carte grise</b> est supervisé par <b>votre point de vente Ewigo</b>,
                                    vous assurant <b>un accompagnement intégral</b> de votre projet auto.
                                </li>
                                <li>
                                    Une fois le contrat d’achat / vente finalisé, Ewigo acte la cession du véhicule
                                    et génère la nouvelle carte grise qui sera délivrée au client acheteur dans un
                                    délai maximal d’un mois.
                                </li>
                            </ul>
                            </p>
                        </div>
                        <div class="col-lg-5">
                            <div class="image-block"><img
                                src="https://www.ewigo.com/wp-content/uploads/2026/01/CARTE_GRISE_EWIGO.png"
                                alt="" class="img-fluid"></div>
                        </div>
                    </div>
                </div>
            </section>


        </div>
    </Layout>
    <Footer :agency="agency" :bg_img="bg_img"></Footer>
</template>

<script>
import _, {throttle} from 'lodash';
import Layout from './Ads/Layout'
import {Head} from '@inertiajs/inertia-vue3'
import Footer from "@/Pages/Partials/Footer"
import Header from "@/Pages/Partials/Header"
import Ad from "@/Pages/Partials/Ad"

export default {
    components: {
        Head,
        Layout,
        Footer,
        Header,
        Ad,
    },
    props: {
        agency: Object,
        title: String,
        description: String,
        bg_img: String,
        body_class: String,
        ads: Object,
        members: Object,
        update_date: String,
    },
    data() {
        return {}
    },
    mounted() {
        document.body.classList.add(this.body_class.split(' '))
    },
    destroyed() {
        document.body.classList.remove(this.body_class.split(' '))
    },
}
</script>

<style scoped>
.the-packs-section .list-block .image-block img {
    max-height: 200px !important;
}
.img-right {
    text-align: r
}

.border-right-orange {
    border-right: 1px solid transparent; /* bordure uniquement à droite */
    border-image: linear-gradient(to bottom, white 40%, orange 40% 90%, white 90%) 1;
    border-image-slice: 1;
}

@media screen and (max-width: 991px) {
    .border-right-orange {
        border-right: none;
        border-image: none;
    }
}

.text-padding {
    padding-left: 15px;
    padding-right: 15px;
}

.pack-text {
    font-family: Poppins;
    font-weight: 300;
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
}

.price-subtitle {
  font-family: Poppins;
  font-weight: 300;
  font-size: 12px;
  line-height: 30px;
  letter-spacing: 0%;
  text-align: center;
}

@media screen and (min-width: 1024px) {
    .full-width img {
        width: 85%;
    }
}
.checklist li {
    padding-bottom: 0;
}

@media screen and (max-width:991px) {
    .center-mobile {
        text-align:center;
    }
    .content-with-left-image-section .image-block img, .content-with-right-image-section .image-block img {
        width: 65%;
    }
    .content-with-left-image-section .row {
        flex-direction: column;
    }
    .content-with-right-image-section .row {
        flex-direction: column-reverse;
    }
    .text-padding {
        padding-top: 20px;
    }
    .content-with-left-image-section, .content-with-right-image-section {
        padding-top: 0;
    }
    .content-with-left-image-section {
        padding-bottom: 0;
    }
    .the-packs-section .list-block .image-block {
        height: 200px;
        width: auto;
        margin: 40px auto;
    }
    .the-packs-section h2 {
        margin-left: 40px;
        margin-right: 40px;
    }
    .the-packs-section .section-header::after {
        height: 1px;
    }
    .section-header:after {
        display: block;
    }
    .video-with-content-section .row {
        flex-direction: column-reverse;
    }
    .video-with-content-section .row {
        flex-direction: column-reverse;
    }
    .text-video {
        padding-bottom: 20px;
    }
    .the-packs-section {
        padding: 20px 0;
    }
    .livraison-subtitle {
        margin-top: 20px;
    }
}
@media screen and (min-width:992px) {

    .the-packs-section h2 {
        margin-left: 80px;
        margin-right: 40px;
    }
}
.the-grey-card-section li:not(:last-child):after, .the-delivery-section li:not(:last-child):after {
    top: 25px;
}

.video-with-content-section {
    padding-bottom: 0;
}

@media screen and (max-width:380px) {
    #paiement-securise h2{
        margin-right: 60px;
    }
}
@media screen and (max-width:430px) {
    #paiement-securise h2{
        margin-right: 100px;
    }
}
@media screen and (max-width:465px) {
    #paiement-securise h2{
        margin-right: 130px;
    }
}

#packs h3 {
    font-weight: bold;
}

.pointer-events-none {
    pointer-events: none;
}


</style>

